module.exports = __webpack_public_path__ + "static/img/ROME_PAINT.6700e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/ROME_PAINT.jpg
// module id = wFzK
// module chunks = 0